import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import ActionsMenu from "@/components/dashboard/ActionsMenu";
import { CardType } from "../types";

export interface CardTypeColumnOptions {
  onEdit: (cardType: CardType) => void;
  onDelete: (cardType: CardType) => void;
}

export function createCardTypeColumns(options: CardTypeColumnOptions): ColumnDef<CardType>[] {
  return [
    { accessorKey: "id", header: "ID" },
    { accessorKey: "type", header: "Type Name" },
    {
      accessorKey: "description",
      header: "Description",
      cell: ({ row }) => {
        const desc = row.getValue("description") as string | undefined;
        if (!desc) return <span className="text-muted-foreground">—</span>;
        return (
          <span className="line-clamp-2 max-w-xs" title={desc}>
            {desc}
          </span>
        );
      },
    },
    {
      accessorKey: "created_at",
      header: "Created At",
      cell: ({ row }) => {
        const raw = row.getValue("created_at") as string | undefined;
        if (!raw) return <span>—</span>;
        const d = new Date(raw);
        if (isNaN(d.getTime())) return <span>{raw}</span>;
        const pad = (n: number) => String(n).padStart(2, "0");
        return <span>{`${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`}</span>;
      },
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const cardType = row.original;
        return (
          <ActionsMenu
            onEdit={() => options.onEdit(cardType)}
            onDelete={() => options.onDelete(cardType)}
          />
        );
      },
    },
  ];
}
